import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2" }, " 💸 Petit budget ", -1)

import { defineComponent } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import LibraryCarouselPriceTagCard from '@/components/library/LibraryCarouselPriceTagCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LibraryCarouselByTagPrice',
  setup(__props) {

defineComponent({
  name: 'LibraryCarouselByTagPrice',
});

return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_component_ion_row, { class: "mb-5" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, { size: "12" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_unref(Swiper), { "slides-per-view": 2.2 }, {
        default: _withCtx(() => [
          _createVNode(_unref(SwiperSlide), null, {
            default: _withCtx(() => [
              _createVNode(LibraryCarouselPriceTagCard, { "tag-price": "cheap" })
            ]),
            _: 1
          }),
          _createVNode(_unref(SwiperSlide), null, {
            default: _withCtx(() => [
              _createVNode(LibraryCarouselPriceTagCard, { "tag-price": "reasonable" })
            ]),
            _: 1
          }),
          _createVNode(_unref(SwiperSlide), null, {
            default: _withCtx(() => [
              _createVNode(LibraryCarouselPriceTagCard, { "tag-price": "expensive" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})